import { motion } from 'framer-motion'
import React, { useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'
import LogoComponent from '../subComponents/LogoComponent'
import PowerButton from '../subComponents/PowerButton'
import SocialIcons from '../subComponents/SocialIcons'
import { YinYang } from './AllSvgs'
import Intro from './Intro'

/* ---------------- MAIN CONTAINER ---------------- */

const MainContainer = styled.div`
background: ${props => props.theme.body};
width: 100vw;
height: 100vh;
overflow-x: hidden;
position: relative;

h2{
  font-family:'Karla', sans-serif;
  font-weight:500;
  font-size: clamp(0.9rem, 1.1vw, 1.1rem);
  letter-spacing: 1px;
  position: relative;
}

h2::after{
  content:'';
  position:absolute;
  left:50%;
  bottom:-4px;
  width:0%;
  height:2px;
  background:currentColor;
  transform:translateX(-50%);
  transition:width 0.6s ease;
}

h2:hover::after{
  width:100%;
}

/* 🔥 1440px and above → 24px */
@media (min-width: 1440px) {
  h2{
    font-size: 24px;
  }
}

/* 📱 MOBILE + INTRO OPEN */
@media (max-width: 425px) {
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.click && `
    background: linear-gradient(
      to bottom,
      #000000 50%,
      #FCF6F4 50%
    );
  `}
}


 
`

const Container = styled.div`
padding: 2rem;
`

/* ---------------- OVERLAYS ---------------- */

const commonOverlay = `
position: fixed;
width: 100%;
height: 100%;
background: rgba(255, 255, 255, 0.8);
backdrop-filter: blur(4px);
z-index: 999;
transition: transform 1.3s cubic-bezier(0.65, 0, 0.35, 1);
`

// Right → Left (Feats)
const RightOverlay = styled.div`
${commonOverlay}
top:0;
right:0;
transform: translateX(${props => props.active ? "0%" : "100%"});
`

// Left → Right (Projects)
const LeftOverlay = styled.div`
${commonOverlay}
top:0;
left:0;
transform: translateX(${props => props.active ? "0%" : "-100%"});
`

// Bottom → Top (About)
const BottomOverlay = styled.div`
${commonOverlay}
bottom:0;
left:0;
transform: translateY(${props => props.active ? "0%" : "100%"});
`

// Top → Bottom (Skills)
const TopOverlay = styled.div`
${commonOverlay}
bottom:0;
left:0;
transform: translateY(${props => props.active ? "0%" : "100%"});
`

const ExperienceOverlay = styled.div`
  ${commonOverlay}
  top: 0;
  left: 0;

  /* 🔥 Desktop animation */
  transform: translateY(${props => props.active ? "0%" : "-100%"});

  /* Mobile ku disable pannrom */
  @media (max-width: 426px) {
    display: none;
  }
`;

const ExperienceLeftOverlay = styled.div`
  ${commonOverlay}
  top: 0;
  left: 0;
  transform: translateX(${props => props.active ? "0%" : "-100%"});

  @media (min-width: 426px) {
    display: none;
  }
`;


/* ---------------- CONTACT ---------------- */

const Contact = styled.a`
color: ${props => props.theme.text};
position: fixed;
top: 2rem;
right: 2rem;
text-decoration: none;
z-index:10;
`

/* ---------------- SIDE LINKS ---------------- */

const FEATS = styled.div`
color: ${props => props.click ? '#000' : props.theme.text};
position: fixed;
top: 50%;
right: 1.5rem;
transform: rotate(90deg);
transform-origin: right top;
letter-spacing: 2px;
font-size: 0.85rem;
z-index: 20;
cursor:pointer;

@media (min-width: 1440px) {
  font-size: 1.2rem;
}

@media (max-width: 425px){
  z-index: 20;
  color: ${props => props.click ? '#FCF6F4' : props.theme.text};
}

`

const PROJECTS = styled.div`
color: ${props => props.click ? '#FCF6F4' : props.theme.text};
position: fixed;
top: 50%;
left: 1.5rem;
transform: rotate(-90deg);
transform-origin: left top;
letter-spacing: 2px;
font-size: 0.85rem;
z-index:10;
cursor:pointer;

@media (min-width: 1440px) {
  font-size: 1.2rem;
}

`

const EXPERIENCE = styled.div`
color: ${props => props.click ? '#FCF6F4' : props.theme.text};
position: fixed;
letter-spacing: 2px;
font-size: 0.85rem;
z-index: 10;
cursor: pointer;

/* ================= DESKTOP (>425px) ================= */
@media (min-width: 426px) {
  top: 2rem; 
  left: 30%;
  transform: translateX(-50%);
}

/* ================= MOBILE (≤425px) ================= */
@media (max-width: 426px) {
  top: 30%;
  left: 1.5rem;
  transform: rotate(-90deg);
  transform-origin: left top;
}

/* Ultra large screens */
@media (min-width: 1440px) {
  font-size: 24px;
}
`;

const BottomBar = styled.div`
position: fixed;
bottom: 1.5rem;
left: 0;
right: 0;
display: flex;
justify-content: space-evenly;
gap: 3rem;
z-index: 20;   /* increase */

@media (max-width: 425px){
  z-index: 20;  /* force above intro */
}
`

const ABOUT = styled.div`
color: ${props => props.click ? '#FCF6F4' : props.theme.text};
font-size: 0.95rem;
letter-spacing: 1px;
cursor:pointer;

@media (min-width: 1440px) {
  font-size: 1.2rem;

}
@media (max-width: 425px) {
color: ${props => props.click ? '#000' : props.theme.text};
}

`

const SKILLS = styled.div`
color: ${props => props.theme.text};
font-size: 0.95rem;
letter-spacing: 1px;
cursor:pointer;

@media (min-width: 1440px) {
color: ${props => props.click ? '#FCF6F4' : props.theme.text};
  font-size: 1.2rem;
}
@media (min-width: 425px) {
color: ${props => props.click ? '#000' : props.theme.text};
}

`

/* ---------------- CENTER YINYANG ---------------- */

const rotate = keyframes`
from{ transform: rotate(0); }
to{ transform: rotate(360deg); }
`

const Center = styled.button`
position: absolute;
top: ${props => props.click ? '85%' :'50%'};
left: ${props => props.click ? '92%' :'50%'};
transform: translate(-50%,-50%);
border: none;
background: transparent;
cursor: pointer;
display: flex;
flex-direction: column;
align-items: center;
transition: all 1s ease;

color: ${props => props.theme.text};   /* 🔥 THIS IS IMPORTANT */

& > :first-child{
  animation: ${rotate} infinite 2s linear;
}

& > span{
  margin-top: 1.2rem;
padding-bottom: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  opacity: 0.9;
  position: relative;
}

/* underline animation */

& > span::after{
  content:'';
  position:absolute;
  left:50%;
  bottom:-4px;
  width:0%;
  height:2px;
  background:currentColor;
  transform:translateX(-50%);
  transition:0.6s ease;
}

&:hover span::after{
  width:100%;
}

&:hover{
transform: translate(-50%,-50%) scale(1.05);
}


@media (max-width: 425px) {

  /* ONLY when Intro open */
  ${props => props.click && `
    top: 88%;
    left: 85%;

    & > :first-child{
      width: 45px !important;
      height: 45px !important;
    }

    & > span{
      font-size: 0.7rem;
    }
  `}
}
`

const DarkDiv = styled.div`
position: absolute;
background-color: #000;
z-index:1;
transition: all 0.5s ease;

/* Desktop behavior */
top: 0;
bottom: 0;
right: 50%;
width: ${props => props.click ? '50%' : '0%'};
height: ${props => props.click ? '100%' : '0%'};

/* 📱 Mobile behavior */
@media (max-width: 425px) {
  right: 0;
  left: 0;
  width: 100%;
  height: ${props => props.click ? '50%' : '0%'};
}
`

/* ---------------- MAIN FUNCTION ---------------- */

const Main = () => {

  const [click, setClick] = useState(false)
  const [yinSize, setYinSize] = useState(110)

  const [featsSlide, setFeatsSlide] = useState(false)
  const [aboutSlide, setAboutSlide] = useState(false)
  const [projectsSlide, setProjectsSlide] = useState(false)
  const [skillsSlide, setSkillsSlide] = useState(false)
  const [experienceSlide, setExperienceSlide] = useState(false)
  const [experienceSlideDesktop, setExperienceSlideDesktop] = useState(false)

  const navigate = useNavigate();

// For FullScreen When Users Click YinYang :
  const enableFullscreen = () => {
  const elem = document.documentElement;

  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  }
  else if (elem.webkitRequestFullscreen) {
    elem.webkitRequestFullscreen();
  }
  else if (elem.msRequestFullscreen) {
    elem.msRequestFullscreen();
  }
}



  const goPage = (setter, path) => {
    setter(true)
    setTimeout(() => navigate(path), 1300)
  }

  useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth >= 769) {
      setYinSize(160)   // 🔥 desktop big size
    } else {
      setYinSize(110)   // 🔥 normal size
    }
  }

  handleResize()
  window.addEventListener("resize", handleResize)

  return () => window.removeEventListener("resize", handleResize)
}, [])

  return (
    <MainContainer click={click}>

      <RightOverlay active={featsSlide}/>
      <LeftOverlay active={projectsSlide}/>
      <ExperienceLeftOverlay active={experienceSlide}/>
      <BottomOverlay active={aboutSlide}/>
      <TopOverlay active={skillsSlide}/>
      <ExperienceOverlay active={experienceSlideDesktop} />

      <DarkDiv click={click}/>

      <Container>

        <PowerButton />
        <LogoComponent theme={click ? 'dark' :'light'}/>
        <SocialIcons theme={click ? 'dark' :'light'} />

        <Center click={click}>
              <YinYang
                onClick={() => {
                  enableFullscreen();
                  setClick(!click);
                }}
                width={click ? 60 : yinSize}
                height={click ? 60 : yinSize}
                fill='currentColor'
              />

            {!click && <span>Explore →</span>}
        </Center>

        <Contact href="https://mail.google.com/mail/?view=cm&fs=1&to=rajaretnam.rajasekar@gmail.com">
          <motion.h2
            initial={{y:-200}}
            animate={{y:0}}
            transition={{type:'spring', duration:1.2}}
          >
            Say hi..
          </motion.h2>
        </Contact>

        <FEATS click={click} onClick={() => goPage(setFeatsSlide, "/blog")}>
          <motion.h2 initial={{y:-200}} animate={{y:0}} transition={{type:'spring', duration:1.2}}>
            Feats
          </motion.h2>
        </FEATS>

        <PROJECTS click={click} onClick={() => goPage(setProjectsSlide, "/work")}>
          <motion.h2 initial={{y:-200}} animate={{y:0}} transition={{type:'spring', duration:1.2}}>
            Projects
          </motion.h2>
        </PROJECTS>

        <EXPERIENCE click={click} onClick={() => {
  if (window.innerWidth > 426) {
    setExperienceSlideDesktop(true)
    setTimeout(() => navigate("/experience"), 1300)
  } else {
    goPage(setExperienceSlide, "/experience")
  }
}}>
          <motion.h2 initial={{y:-200}} animate={{y:0}} transition={{type:'spring', duration:1.2}}>
            Experience
          </motion.h2>
        </EXPERIENCE>

        <BottomBar>
          <ABOUT click={click} onClick={() => goPage(setAboutSlide, "/about")}>
            <motion.h2 initial={{y:200}} animate={{y:0}} transition={{type:'spring', duration:1.2}}>
              About.
            </motion.h2>
          </ABOUT>

          <SKILLS click={click} onClick={() => goPage(setSkillsSlide, "/skills")}>
            <motion.h2 initial={{y:200}} animate={{y:0}} transition={{type:'spring', duration:1.2}}>
              My Skills.
            </motion.h2>
          </SKILLS>
        </BottomBar>

      </Container>

      {click && <Intro click={click} />}

    </MainContainer>
  )
}

export default Main